export const formatPhoneNumber = (phone?: string): string => {
  if (!phone) return '';

  // 10자리 전화번호는 010-123-1234 형식
  if (phone.length === 10) {
    return `${phone.slice(0, 3)}-${phone.slice(3, 6)}-${phone.slice(6, 10)}`;
  }

  // 11자리 전화번호는 010-1234-5678 형식
  if (phone.length === 11) {
    return `${phone.slice(0, 3)}-${phone.slice(3, 7)}-${phone.slice(7, 11)}`;
  }

  // 그 외의 경우 원본 반환
  return phone;
};
